export class CanalCommunication {
    id: number;
    name: string;
}


